import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getOwnerReactionType(message: Message): string | null {
    // If it is set then just return the value
    if (message.OwnerReactionType) {
        return message.OwnerReactionType;
    }

    // GCI is not returning OwnerReactionType
    // So get it from the Reactors list
    if (message.Reactions) {
        const userEmailAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
        for (const reaction of message.Reactions) {
            if (
                reaction.Reactors.some(
                    reactor => reactor.ReactorEmail.EmailAddress === userEmailAddress
                )
            ) {
                return reaction.ReactionType;
            }
        }
    }

    return null;
}
